import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  variant?: 'filter' | 'tone' | 'blur';
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
}
export function Chip({ active, variant = 'filter', iconLeft, iconRight, className, children, ...rest }: Props) {
  const base = 'inline-flex items-center gap-1.5 min-h-8 px-3 py-2 rounded-full text-[13px] leading-none font-medium font-sans whitespace-nowrap transition select-none';
  const v = {
    filter: active
      ? 'bg-ink-1 text-paper ring-1 ring-ink-1'
      : 'bg-paper-elev text-ink-1 ring-1 ring-paper-edge hover:bg-paper-rec',
    tone: 'bg-paper-rec text-ink-2 ring-0',
    blur: active
      ? 'bg-ink-1 text-paper'
      : 'blur-chip text-ink-1 ring-1 ring-paper-edge',
  }[variant];
  return (
    <button className={cn(base, v, className)} {...rest}>
      {iconLeft}{children}{iconRight}
    </button>
  );
}
